import { createContext } from 'react'

const AppMagicLayoutContext = createContext({
  hasMagicLayout: false,
})

AppMagicLayoutContext.displayName = 'AppMagicLayoutContext'

export default AppMagicLayoutContext
